module.exports = __webpack_public_path__ + "img/lambdoge.614dce28.png";